import AddCommentRoundedIcon from "@mui/icons-material/AddCommentRounded";
import ArchiveRoundedIcon from "@mui/icons-material/ArchiveRounded";
import SettingsApplicationsRoundedIcon from "@mui/icons-material/SettingsApplicationsRounded";
import { Divider } from "@mui/material";
import { t } from "i18next";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import CoreButtonHoverIcon from "../../../app/core/components/CoreButtonIcon/CoreButtonHoverIcon";
import {
  useDeleteArchivedConversationMutation,
  useGetAllBotQuery,
  useGetArchivedConversationsQuery,
  useGetConversationByIdQuery,
  useLazyGetConversationByIdQuery,
} from "../../api/admin/chatbotApi";
import ButtonBot from "./ButtonBot";
import ChatArchiveTable from "./ChatArchiveTable";
import ChatBot from "./ChatBot";
import CoreSpinner from "../../../app/core/components/CoreSpinner/CoreSpinner";
import { ROLE } from "../../../utils/constants/profiles";
import AutoAwesomeRoundedIcon from "@mui/icons-material/AutoAwesomeRounded";

const ChatBotPage = () => {
  const navigate = useNavigate();
  const role = useSelector((state) => state.app.role);
  const colorPrimary = useSelector((state) => state.app.primaryColor);
  const colorSecondary = useSelector((state) => state.app.secondaryColor);
  const [openBot, setOpenBot] = useState(false);
  const [bots, setBots] = useState();
  const [idBot, setIdBot] = useState();
  const [chatKey, setChatKey] = useState(0);
  const [showArchive, setShowArchive] = useState(false);
  const [showListBot, setShowListBot] = useState(true);
  const [selectedConversationId, setSelectedConversationId] = useState(null);
  const [chatHistory, setChatHistory] = useState([]);
  const [conversations, setConversations] = useState([]);

  const { data: getAllBot, isLoading: loadingBot } = useGetAllBotQuery();

  const {
    data: conversationsRaw,
    isLoading: isLoadingConversations,
    refetch,
  } = useGetArchivedConversationsQuery(undefined, {
    skip: !showArchive,
  });

  const { data: conversationData, isLoading: isLoadingConversation } =
    useGetConversationByIdQuery(selectedConversationId, {
      skip: !selectedConversationId,
    });
  const [deleteArchivedConversation] = useDeleteArchivedConversationMutation();
  const [triggerGetConversationById] = useLazyGetConversationByIdQuery();

  const conversation = conversationData?.conversation || null;

  // Calcola la prop da passare a ChatBot
  const conversationToShow =
    openBot && selectedConversationId
      ? {
          ...conversation,
          conversationId: conversation?.id,
        }
      : null;

  useEffect(() => {
    if (getAllBot && getAllBot.agents) {
      setBots(getAllBot.agents);
    }
  }, [getAllBot]);

  useEffect(() => {
    if (conversationsRaw && conversationsRaw.conversations) {
      setConversations(conversationsRaw.conversations);
    }
  }, [conversationsRaw]);

  // Svuota la chat quando cambi bot e NON stai guardando una conversazione archiviata
  useEffect(() => {
    if (openBot && !selectedConversationId) {
      setChatHistory([]);
    }
  }, [idBot, openBot, selectedConversationId]);

  // Funzioni toggle
  const handleSelectedBot = (botId) => {
    if (openBot && idBot === botId && selectedConversationId === null) {
      // Deseleziona se clicchi sul bot già selezionato
      setOpenBot(false);
      setIdBot(undefined);
      setSelectedConversationId(null);
      setChatKey((prev) => prev + 1);
    } else {
      setOpenBot(true);
      setIdBot(botId);
      setSelectedConversationId(null);
      setChatKey((prev) => prev + 1);
    }
  };

  // Funzione per nuova conversazione
  const handleNewConversation = () => {
    setOpenBot(true);
    // Seleziona il primo bot della lista se presente
    let firstBotId;
    if (Array.isArray(getAllBot?.agents) && getAllBot.agents.length > 0) {
      firstBotId = getAllBot.agents[0].id;
    }
    setIdBot(firstBotId);
    setSelectedConversationId(null);
    setChatKey((prev) => prev + 1);
    setChatHistory([]);
    if (showArchive) {
      refetch();
    }
  };

  const handleOpenArchivedConversation = (conv) => {
    setOpenBot(true);
    setSelectedConversationId(conv.id);
    setIdBot(conv.agentId);
    setChatKey((prev) => prev + 1);
    // triggera il refetch delle conversazioni archiviate qui
    // triggerGetArchivedConversations();
  };

  if (loadingBot) {
    return <CoreSpinner />;
  }

  const handleActiveBot = (bot) => {
    const cond =
      openBot &&
      idBot === bot.id &&
      (selectedConversationId === null ||
        (selectedConversationId !== null && idBot === bot.id));
    return cond;
  };

  return (
    <div>
      <h2>{t("SmartAssistant")}</h2>
      <div className="flex w-full justify-between items-center">
        <CoreButtonHoverIcon
          onClick={() => setShowListBot(!showListBot)}
          className="text-primary m-1"
          icon={<AutoAwesomeRoundedIcon className="text-primary" />}
          testo={showListBot ? t("Hide") : t("Show")}
        />
        <div>
          <CoreButtonHoverIcon
            onClick={handleNewConversation}
            className="text-blue-700 m-1"
            icon={<AddCommentRoundedIcon className="fill-blue-700" />}
            testo={t("Nuova chat")}
          />
          <CoreButtonHoverIcon
            onClick={() => setShowArchive((prev) => !prev)}
            className="text-orange-600 m-1"
            icon={<ArchiveRoundedIcon className="fill-orange-600" />}
            testo={t("Archivio")}
          />
          {role === ROLE.ADMIN && (
            <CoreButtonHoverIcon
              onClick={() => navigate("/auth/admin/chat-bot-settings")}
              className="text-green-700 m-1"
              icon={
                <SettingsApplicationsRoundedIcon className="fill-green-700" />
              }
              testo={t("Settings")}
            />
          )}
        </div>
      </div>
      <div className="flex mt-5 gap-8">
        {/* Colonna sinistra */}
        {showListBot && (
          <div
            className="w-2/12 flex h-[75vh] flex-col space-y-4 p-6 overflow-auto rounded-lg "
            style={{
              border: "1px solid lightgrey",
              transition: "width 0.3s",
              maxHeight: "58rem",
            }}
          >
            {bots?.map((el) => (
              <React.Fragment key={el.id}>
                <ButtonBot
                  disabled={handleActiveBot(el)}
                  style={
                    handleActiveBot(el)
                      ? {
                          color: `${colorSecondary}`,
                          borderColor: `${colorSecondary}`,
                        }
                      : {
                          color: `${colorPrimary}`,
                          borderColor: `${colorPrimary}`,
                        }
                  }
                  onOpen={() => handleSelectedBot(el.id)}
                  img={el.iconUrl}
                  iconText={handleActiveBot(el) ? t("SelectedAgent") : el.name}
                  text={el.description}
                />

                <Divider />
              </React.Fragment>
            ))}
          </div>
        )}

        {/* Colonna centrale: chatbot */}
        <div
          className={`${
            showArchive ? "w-8/12" : "w-full"
          } h-[75vh] rounded-lg flex flex-col px-6`}
          style={{
            border: "1px solid lightgrey",
            transition: "width 0.3s",
          }}
        >
          {openBot ? (
            <ChatBot
              key={chatKey}
              idBot={idBot}
              conversation={conversationToShow}
              loadingConversation={isLoadingConversation}
              chatHistory={chatHistory}
              setChatHistory={setChatHistory}
              onMessageSent={() => {
                if (selectedConversationId) {
                  triggerGetConversationById(selectedConversationId, true);
                }
                refetch();
              }}
            />
          ) : (
            <p className="w-full h-full text-lightgray flex justify-center items-center text-xl">
              {t("NotSelectedAgent")}
            </p>
          )}
        </div>

        {/* Colonna destra: archivio conversazioni */}
        {showArchive && (
          <div className="w-4/12 h-full pl-2">
            <ChatArchiveTable
              conversations={conversations}
              loading={isLoadingConversations}
              onOpen={handleOpenArchivedConversation}
              onDelete={async (conv) => {
                await deleteArchivedConversation(conv.id);
                if (showArchive) {
                  refetch();
                }
                // Se la chat eliminata è quella attualmente aperta, pulisce l’interfaccia
                if (selectedConversationId === conv.id) {
                  setSelectedConversationId(null);
                  setChatHistory([]);
                  setOpenBot(false); // opzionale: chiude la chat
                  setIdBot(undefined); // opzionale: deseleziona il bot
                  setChatKey((prev) => prev + 1); // forza il remount del ChatBot
                }
              }}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default ChatBotPage;
